<template>
<div class="chapter">
<div class="inner_page">
<article epub:type="chapter">
<div epub:type="bodymatter">
<section epub:type="division">
<p class="toc"><a id="page5"></a><a href="#/OEBPS/9781454936749_int">Introduction: Living with plants</a></p>
<p class="toc1"><a href="#/OEBPS/9781454936749_c01"><b>01</b> Plants for calm and relaxation</a></p>
<p class="toc"><span href="#/OEBPS/9781454936749_c02" title="Link target outside of Sample"><b>02</b> Plants for a breath of fresh air</span></p>
<p class="toc"><span href="#/OEBPS/9781454936749_c03" title="Link target outside of Sample"><b>03</b> Plants for a good night’s sleep</span></p>
<p class="toc"><span href="#/OEBPS/9781454936749_c04" title="Link target outside of Sample"><b>04</b> Plants to improve well-being</span></p>
<p class="toc"><span href="#/OEBPS/9781454936749_c05" title="Link target outside of Sample"><b>05</b> Plants to reduce stress</span></p>
<p class="toc"><span href="#/OEBPS/9781454936749_c06" title="Link target outside of Sample"><b>06</b> Plants that bring joy and happiness</span></p>
<p class="toc"><span href="#/OEBPS/9781454936749_c07" title="Link target outside of Sample"><b>07</b> Plants for the workspace</span></p>
<p class="toc"><span href="#/OEBPS/9781454936749_c08" title="Link target outside of Sample"><b>08</b> Plants to help you get well soon</span></p>
<p class="toc"><span href="#/OEBPS/9781454936749_c09" title="Link target outside of Sample"><b>09</b> Plants to boost brain power and focus</span></p>
<p class="toc"><span href="#/OEBPS/9781454936749_c10" title="Link target outside of Sample"><b>10</b> Plants to help you communicate and relate</span></p>
<p class="toc1"><span href="#/OEBPS/9781454936749_c11" title="Link target outside of Sample"><b>11</b> How to choose your plants</span></p>
<p class="toc"><span href="#/OEBPS/9781454936749_c12" title="Link target outside of Sample"><b>12</b> Keeping your plants healthy</span></p>
<p class="toc"><span href="#/OEBPS/9781454936749_c13" title="Link target outside of Sample"><b>13</b> Plants to share</span></p>
<p class="toc"><span href="#/OEBPS/9781454936749_c14" title="Link target outside of Sample"><b>14</b> A plant for every room</span></p>
<p class="toc"><span href="#/OEBPS/9781454936749_c15" title="Link target outside of Sample"><b>15</b> Ten easy-going plants</span></p>
<p class="toc1"><span href="#/OEBPS/9781454936749_res" title="Link target outside of Sample">Resources and Stockists</span></p>
<p class="toc"><span href="#/OEBPS/9781454936749_ata" title="Link target outside of Sample">About the Author</span></p>
</section>
</div>
</article>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9781454936749_toc.vue?4e18da95